import { createContext, PropsWithChildren } from "react";

import { OthersEntries } from "shared/catalog/OthersCatalog/others-catalog.helper";

type OthersContextData = OthersEntries | undefined;

export const OthersContext = createContext<OthersContextData>(undefined);

type OthersContextProps = { entries: OthersEntries };

export const OthersContextProvider = ({
  children,
  entries,
}: PropsWithChildren<OthersContextProps>) => (
  <OthersContext.Provider value={entries}>{children}</OthersContext.Provider>
);
